import { Elements } from '@stripe/react-stripe-js';
import { StripeElementsOptions } from '@stripe/stripe-js';
import { stripePromise } from '@/config';
import { CardCheckoutForm } from './Card';

type TariffsPaymentMethodProps = {
  planId: number;
  amount: number;
  onSuccess?: () => void;
};

const ELEMENTS_OPTIONS: StripeElementsOptions = {
  fonts: [
    {
      cssSrc:
        'https://fonts.googleapis.com/css2?family=Inter:wght@400;500&display=swap',
    },
  ],
};

const TariffsPaymentMethod = ({
  planId,
  amount,
  onSuccess,
}: TariffsPaymentMethodProps) => {
  return (
    <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
      <CardCheckoutForm planId={planId} amount={amount} onSuccess={onSuccess} />
    </Elements>
  );
};

export default TariffsPaymentMethod;
